export class PermissionError extends Error {
  constructor(capability, message = "Permission denied") {
    super(message);
    this.name = "PermissionError";
    this.capability = capability;
  }
}
